import { LoadingSpinner } from '@atrvd/saas-ui'
import { FACILITY_SCOPE_COPY } from './financialAccountsScope'

interface FacilityScopeFallbackProps {
  isLoading: boolean
  error: Error | null
  notFound: boolean
}

/**
 * What a facility-scoped Financial Accounts page shows while its facility
 * (`useFacilityScope`) has not resolved: a spinner, the load error, or that
 * the facility no longer exists.
 */
export function FacilityScopeFallback({ isLoading, error, notFound }: FacilityScopeFallbackProps) {
  return (
    <div className="py-12 text-center">
      {isLoading ? (
        <div className="flex justify-center">
          <LoadingSpinner />
        </div>
      ) : error ? (
        <p role="alert" className="text-destructive">
          {error.message}
        </p>
      ) : notFound ? (
        <p className="text-muted-foreground">{FACILITY_SCOPE_COPY.notFound}</p>
      ) : null}
    </div>
  )
}
